import { Link } from "react-router-dom";
import "../../user/pages/styles/ReportPage.css";
import arrowR from "/assets/ArrowR.svg";

const reportItems = [
  { path: "/report/showweatheradmin", label: "สภาพอากาศ SmartPole" },
  { path: "/report/showwateradmin", label: "รายงานสถานะระดับน้ำรายชั่วโมง" },
  { path: "/report/showwaterleveladmin", label: "รายงานสถานะระดับน้ำ 24 ชั่วโมง" },
];

const smartPoleItems = [
  { path: "/report/showpoleenergyadmin", label: "รายงานสถานะการใช้พลังงานเสา" },
  { path: "/report/showpoleenergy24admin", label: "รายงานสถานะการใช้พลังงานเสา 24 ชั่วโมง" },
  { path: "/report/showdetailedreportadmin", label: "รายงานรายละเอียดของแต่ละเสา (ติดตั้งกล้อง จอ การปรับไฟ)" },
];

const userBranchItems = [
  { path: "/report/showuserreportadmin", label: "รายงานผู้ใช้งานในระบบ SmartPole" },
  { path: "/report/showbranchesadmin", label: "สาขาทั้งหมดในระบบ SmartPole" },
  { path: "/report/showbranchdetailadmin", label: "รายละเอียดของแต่ละสาขา" },
];

const ReportPageAdmin = () => (
  <div className="container-report">
    <div className="container-report-main">
      <h1>รายงาน</h1>
      <h2>รายงานสภาพ</h2>
      <ul>
        {reportItems.map(({ path, label }) => (
          <Link key={path} to={path}>
            <li>
              {label} <img src={arrowR} alt="arrow" />
            </li>
          </Link>
        ))}
      </ul>
      <h2>รายงาน SmartPole</h2>
      <ul>
        {smartPoleItems.map(({ path, label }) => (
          <Link key={path} to={path}>
            <li>
              {label} <img src={arrowR} alt="arrow" />
            </li>
          </Link>
        ))}
      </ul>
      <h2>รายงานผู้ใช้งาน และข้อมูลสาขา</h2>
      <ul>
        {userBranchItems.map(({ path, label }) => (
          <Link key={path} to={path}>
            <li>
              {label} <img src={arrowR} alt="arrow" />
            </li>
          </Link>
        ))}
      </ul>
    </div>
  </div>
);

export default ReportPageAdmin;